import React from 'react';

interface ClientTypeBadgeProps {
    type: 'PERSON' | 'COMPANY';
    size?: 'sm' | 'md';
}

export const ClientTypeBadge: React.FC<ClientTypeBadgeProps> = ({ type }) => {
    const isPerson = type === 'PERSON';

    const config = isPerson
        ? {
            color: 'bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-900/30 dark:text-sky-300 dark:border-sky-800',
            dot: 'bg-sky-600 dark:bg-sky-400',
            label: 'Persona',
        }
        : {
            color: 'bg-indigo-100 text-indigo-800 border-indigo-200 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border-indigo-800',
            dot: 'bg-indigo-600 dark:bg-indigo-400',
            label: 'Empresa',
        };

    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-medium ${config.color}`}>
            <span className={`block h-1.5 w-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
            {config.label}
        </span>
    );
};
